import React from "react";
import { cx, css } from "emotion";
import { useMutation, useQuery } from "react-query";
import DeliveryService from "../../../Services/DeliveryService";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { notifUtils } from "../../../components/NotifUtils/NotifUtils";
import { handleError } from "../../../components/Utils/Utils";

const user = JSON.parse(localStorage.getItem("user"));
const DeliveryCourier = (props) => {
  const { isMobile } = props;
  const [deliveryPackages, setDeliveryPackages] = React.useState([]);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { isValid },
    control,
    watch,
    reset,
  } = useForm({
    mode: "all",
    reValidateMode: "onChange",
    shouldUnregister: false,
  });
  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray(
    {
      control,
      name: "property_deliveries",
    }
  );

  const watchFields = watch();

  const getDeliveryPackages = useQuery(
    ["getDeliveryPackages-Tenant", user?.tenant?.id],
    () => {
      return DeliveryService.getDeliveryTenantAll(user?.tenant?.id || 0).then(
        (res) => res.data
      );
    },
    {
      enabled: false,
      cacheTime: 0,
      retry: false,
      onSuccess: (data) => {
        if (data?.length > 0) {
          for (let i = 0; i < data?.length; i++) {
            if (data[i].delivery_packages?.length > 0) {
              for (let j = 0; j < data[i].delivery_packages?.length; j++) {
                setValue(`property_deliveries.${i + j}`, {
                  id: data[i].delivery_packages[j]?.id,
                  checked_st: data[i].delivery_packages[j]?.checked_st || false,
                });
              }
            }
          }
        }
        setDeliveryPackages(data);
      },
    }
  );

  // Mutation
  const mutationMappingDelivery = useMutation(
    DeliveryService.postDeliveryPackageTenant,
    {
      onSuccess: (data, variables) => {
        notifUtils("Success Save Tenant Delivery Package", "success");

        getDeliveryPackages.refetch();
      },
      onError: (error, variables) => {
        handleError(error.toString());
      },
    }
  );

  const onSubmit = (data) => {
    let { property_deliveries } = data;

    const temp_filter = property_deliveries?.filter(
      (val) => val?.checked_st === true
    );
    const delivery_package_ids = temp_filter?.map((val) => val?.id);

    const id = user?.tenant?.id;
    const params = {
      tenant_id: id,
      delivery_package_ids: delivery_package_ids || [],
    };

    mutationMappingDelivery.mutate(params);
  };

  const handleChangeDelivery = (id, event) => {
    setValue(event.target.name, {
      id: id,
      checked_st: event.target.value,
    });
  };

  React.useEffect(() => {
    getDeliveryPackages.refetch();
  }, [user]);

  return (
    <div
      className={cx(
        css`
          ${isMobile ? "width: 100%;" : "width: 400px"}
        `,
        "px-3 py-2"
      )}
    >
      <h2 className="font-20 font-bold">Pengaturan Pengiriman</h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row mt-4">
          {!getDeliveryPackages?.isLoading && getDeliveryPackages?.isSuccess && (
            <div className="col-12">
              <div
                className="d-flex flex-wrap justify-content-start align-items-start"
                style={{ gap: 8 }}
              >
                {!getDeliveryPackages.isLoading &&
                  getDeliveryPackages?.isSuccess &&
                  deliveryPackages?.length > 0 &&
                  deliveryPackages?.map(
                    (val, key) =>
                      val?.delivery_packages?.length > 0 && (
                        <div className="p-3" key={val?.id}>
                          <span className="font-14 font-bold">{val?.name}</span>
                          <ul className="list-group list-group-flush">
                            {val?.delivery_packages?.length > 0 &&
                              val?.delivery_packages?.map((item, idx) => (
                                <li
                                  className="list-group-item"
                                  key={key + "-" + item?.id}
                                >
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={
                                          watchFields[`property_deliveries`] &&
                                          watchFields[`property_deliveries`]
                                            .length > 0 &&
                                          watchFields[`property_deliveries`][
                                            key + idx
                                          ] &&
                                          watchFields[`property_deliveries`][
                                            key + idx
                                          ]["checked_st"] === true
                                        }
                                        onChange={(e) =>
                                          handleChangeDelivery(item?.id, {
                                            target: {
                                              name: e.target.name,
                                              value: e.target.checked,
                                            },
                                          })
                                        }
                                        name={`property_deliveries.${
                                          key + idx
                                        }`}
                                        color="primary"
                                        control={control}
                                      />
                                    }
                                    label={item?.name}
                                  />
                                </li>
                              ))}
                          </ul>
                        </div>
                      )
                  )}
              </div>
            </div>
          )}
          {getDeliveryPackages?.isLoading && (
            <div className="col-12">
              <p className="font-14 font-bold text-center">
                Get Delivery Package ...
              </p>
            </div>
          )}

          <div className="col-12 text-right">
            {mutationMappingDelivery?.isLoading && (
              <button
                type="submit"
                className="btn bg-blue text-white rounded-8px border-0 font-12"
                disabled={true}
              >
                SIMPAN
              </button>
            )}
            {!mutationMappingDelivery?.isLoading && (
              <button
                type="submit"
                className={
                  isValid
                    ? "btn bg-blue text-white rounded-8px border-0 font-12"
                    : "btn bg-gray-757575 text-white rounded-8px border-0 font-12"
                }
                disabled={!isValid}
              >
                SIMPAN
              </button>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default DeliveryCourier;
